import "bootstrap";
import "bootstrap/dist/css/bootstrap.css"; // Import precompiled Bootstrap css
import "bootstrap/dist/js/bootstrap.bundle.min";
import "@fortawesome/fontawesome-free/css/all.css";
import $ from "jquery";

import { StaminaService } from "@wjossowski/tibia-calculators";
import "moment-duration-format";
import "moment/locale/pl";
import moment, { duration } from "moment";

const getMinutes = (value) => {
  const parts = `${value}`.split(":");
  if (parts.length !== 2) {
    throw new Error("Niewłaściwy format godziny");
  }

  const [hoursRaw, minutesRaw] = parts;
  const hours = parseInt(hoursRaw);
  const minutes = parseInt(minutesRaw);

  if ([hours, minutes].some((x) => !Number.isSafeInteger(x))) {
    throw new Error("Niewłaściwy format godziny");
  }

  if (hours < 0 || hours > 42) {
    throw new Error("Niewłaściwy zakres godzin");
  }

  if (minutes < 0 || minutes > 59) {
    throw new Error("Niewłaściwy zakres minut");
  }

  if (hours === 42 && minutes !== 0) {
    throw new Error("Maksymalnie 42h");
  }

  return 60 * hours + minutes;
};

const buildOutput = (dur, time, to) => {
  return `
  <tr>
  <td>Czas potrzebny do regeneracji:</td>
  <td><b>${dur}</b></td>
  </tr>
  <tr>
  <td>Jeśli wylogujesz się teraz, to ${
    to === 60 * 42 ? "pełną" : "ustawioną"
  } staminę uzyskasz:</td>
  <td><b>${time}</b></td>
  </tr>`;
};

const calculate = () => {
  try {
    const from = getMinutes(document.querySelector("input#from").value);
    const to = getMinutes(document.querySelector("input#to").value);

    if (from > to) {
      throw new Error("Docelowa stamina musi być większa od aktualnej");
    }

    const minutes = StaminaService.calculateStamina(from, to);
    const dur = duration(minutes, "minutes").format("HH:mm");
    const time = moment(new Date())
      .add(minutes, "minutes")
      .locale("pl")
      .format("dddd, DD MMMM o HH:mm");

    document.querySelector("#result").innerHTML = buildOutput(dur, time, to);
  } catch (error) {
    document.querySelector("#result").innerHTML = error.message;
  }
};

const setMax = () => {
  $("input#to").val("42:00");
  calculate();
};

$(() => {
  $("input#from").on("change", calculate);
  $("input#to").on("change", calculate);
  $("button#maxStamina").on("click", setMax);

  calculate();
});
